import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { BasicAuthService } from '../../../../../services/basic-auth.service'
import { HttpErrorResponse } from '@angular/common/http'
import { DownloaderService } from '../../../../../services/downloader.service'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { InstalledModule, IVersioning } from '../../../../../models/login-response.model'
import { SpasLicenseService } from '../../../../../services/admin/plant-setup/spas-license.service'
import { Subscription } from 'rxjs'
import { SystemInfoModel } from '../../../../../models/system-info.model'
import { IUserModel } from '../../../../../models/user.model'
import { environment } from '../../../../../../environments/environment'

@Component({
  selector: 'app-topbar-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  standalone: false,
})
export class TopbarUserMenuComponent implements OnInit, OnDestroy {
  @Input() systemInfo: SystemInfoModel

  private _licenseSubscription: Subscription

  public name: string
  public surname: string
  public email: string
  public group: string
  public acrAppURL: string = environment.acrAppUrl
  public modules: InstalledModule[] = []
  public versioning: IVersioning

  constructor(
    public authService: BasicAuthService,
    private licenseService: SpasLicenseService,
    private downloaderService: DownloaderService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public hasExcel(): boolean {
    return this.downloaderService.hasExcel()
  }

  public downloadExcel() {
    // As Blob ~ install dependency | import {saveAs} from 'file-saver/FileSaver';
    // this.feaService.getExcelReportAsBlob().subscribe((res: any) => {
    //   const fileBlob = res
    //   const blob = new Blob([fileBlob], {
    //     type: 'application/vnd.ms-excel'
    //   })
    //   // use file saver npm package for saving blob to file
    //   saveAs(blob, `myFile.xlsx`)
    // })

    this.downloaderService.download(DownloaderService.TYPE_EXCEL).subscribe({
      next: (base64: string) => {
        const downloadLink: HTMLAnchorElement = document.createElement('a')
        downloadLink.href =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64
        downloadLink.download = this.downloaderService.getReportName(DownloaderService.TYPE_EXCEL)
        downloadLink.click()
        downloadLink.remove()
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
      },
    })
  }

  public hasPdf(): boolean {
    return this.downloaderService.hasPdf()
  }

  public downloadPdf() {
    this.downloaderService.download(DownloaderService.TYPE_PDF).subscribe({
      next: (base64: string) => {
        const downloadLink: HTMLAnchorElement = document.createElement('a')
        downloadLink.href = 'data:application/pdf;base64,' + base64
        downloadLink.download = this.downloaderService.getReportName(DownloaderService.TYPE_PDF)
        downloadLink.click()
        downloadLink.remove()
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
      },
    })
  }

  public async logout(): Promise<void> {
    await this.authService.logout()
  }

  public hasManual(): boolean {
    return false
    // return this.downloaderService.hasManual()
  }

  public downloadManual(): void {
    this.downloaderService.downloadManual().subscribe({
      next: (response: { status: string; base64: any; fileType: string; fileName: string }) => {
        const downloadLink: HTMLAnchorElement = document.createElement('a')
        downloadLink.href = `data:${response.fileType};base64,` + response.base64
        downloadLink.download = response.fileName
        downloadLink.click()
        downloadLink.remove()
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
      },
    })
  }

  private checkLicenseNotification(): void {
    this._licenseSubscription = this.licenseService.licenseChangeEvent.subscribe(
      (changed: boolean) => {
        if (changed) {
          this.authService.getInstalledModules().subscribe((modules: InstalledModule[]) => {
            this.authService.refreshAppModules(modules)
            this.modules = this.authService.getModules()
          })
        }
      },
    )
  }

  ngOnInit(): void {
    const user: IUserModel = this.authService.getUser()
    this.name = user ? user.UserFirstName : ''
    this.surname = user ? user.UserName : ''
    this.email = user ? user.UserEmail : ''
    this.group = user ? user.group : '-'
    this.modules = this.authService.getModules().filter(m => m.show === undefined || m.show == 1)
    this.versioning = this.authService.getVersioning()
    this.checkLicenseNotification()
  }

  ngOnDestroy(): void {
    if (this._licenseSubscription) {
      this._licenseSubscription.unsubscribe()
    }
  }
}
